// 导入vue
import Vue from 'vue';
// 导入根组件
import App from './App.vue';

import ElementUI from 'element-ui';
Vue.use(ElementUI);
// 导入路由实例
import router from './router/index';
// 导入全局样式文件
import './assets/css/reset.css';
// 导入数据存储对象
// import store from './store/index';
// 导入vant组件库
import './utils/vant';
import axios from '@/utils/axios';
Vue.prototype.$axios = axios;
//自适应
import 'lib-flexible'
// 将数据接口服务器的基础域名挂载到vue的原型对象上, 方便在组件中调用
Vue.prototype.$baseUrl = 'https://saas.hykerp.com/api';
// Vue.prototype.$baseUrl = 'http://2vhihi2exu.tcp01.cn'
new Vue({
    el: '#app',
    // 挂载数据存储对象
    // store:store,
    // render: h => h(App),
    // createElement: vue系统内置的一个方法, 作用是编译组件
    render: function(createElement) {
        return createElement(App);
    },

    // 挂载路由实例
    router: router
});